import { Controller } from '@hotwired/stimulus';
import { LogicEngine } from 'json-logic-engine';

export default class extends Controller {
  static targets = ['ruleInput', 'dataInput', 'output'];

  initialize() { this.engine = new LogicEngine(); }
  connect() { this.debug(); }

  result(rule, data) {
    return rule == null ? null : this.engine.run(rule, data);
  }

  debug() {
    if (!this.hasRuleInputTarget || !this.hasDataInputTarget || !this.hasOutputTarget) return;
    try {
      const result = this.result(JSON.parse(this.ruleInputTarget.value), JSON.parse(this.dataInputTarget.value));
      this.outputTarget.textContent = typeof result === 'string' ? result : JSON.stringify(result ?? null, null, 2);
    } catch (error) {
      this.outputTarget.textContent = `Error: ${error.message || String(error)}`;
    }
  }
}
